import { getLangTxt, langTextInit } from '@blade/common/utils/echartUtils';
import lang from '@blade-sxp/task-management/lang/create-task';
langTextInit(lang);
// 初始化进出口配置
export const initEntranceExitDataConfig = () => {
    return {
        entrance: {
            title: `${getLangTxt('entrance')}`,
            list: [],
            config: {
                tips: {
                    input: `${getLangTxt('entranceInput')}`,
                    select: `${getLangTxt('selectDevice')}`,
                },
            },
        },
        exit: {
            title: `${getLangTxt('exit')}`,
            list: [],
            config: {
                tips: {
                    input: `${getLangTxt('exitInput')}`,
                    select: `${getLangTxt('selectDevice')}`,
                },
            },
        },
    };
};
// 初始化访客画像属性识别
export const initProtraitRecognitionConfig = () => {
    return {
        props: {
            face: {
                title: `${getLangTxt('faceAttrRecognition')}`,
                isChecked: false,
                selectList: [], // 选择的设备列表
            },
            body: {
                title: `${getLangTxt('bodyAttrRecognition')}`,
                isChecked: false,
                selectList: [],
            },
        },
    };
};
// 初始化访客画像输出属性
export const initProtraitOutputConfig = () => {
    return {
        title: `${getLangTxt('attrOutput')}`,
        props: {
            age: {
                title: `${getLangTxt('age')}`,
                val: '',
            },
            gender: {
                title: `${getLangTxt('gender')}`,
                val: '',
            },
        },
    };
};
// 初始化访客画像输出属性单选按钮配置
export const initProtraitOutputRadiosConfig = () => {
    return [
        {
            label: `${getLangTxt('faceAttr')}`,
            key: 'face',
            val: 'face',
            disabled: true,
        },
        {
            label: `${getLangTxt('bodyAttr')}`,
            key: 'body',
            val: 'body',
            disabled: true,
        },
    ];
};
